import { useCustomer } from '@packages/shared/src/hooks/useCustomer/useCustomer';
import type { KimRatingDialogProps } from './KimRating.types';
import { useIFrameUrl } from './useIFrameUrl';

const KimRatingIFrame = (dialogProps: KimRatingDialogProps) => (
  <iframe
    title="kim"
    width="100%"
    height="600"
    style={{ border: 0, overflow: 'hidden' }}
    src={useIFrameUrl(dialogProps)}
  />
);

const CustomerKimRatingIFrame = (dialogProps: KimRatingDialogProps) => {
  const { customer } = useCustomer();
  return <KimRatingIFrame {...dialogProps} kid={customer?.extra?.kid} />;
};

/**
 * Renders the dialog content for the KimRating component.
 *
 * @param props - The component props.
 * @returns The rendered dialog content.
 */
export const KimRatingDialogContent = (dialogProps: KimRatingDialogProps) =>
  dialogProps.kid === undefined ? (
    <CustomerKimRatingIFrame {...dialogProps} />
  ) : (
    <KimRatingIFrame {...dialogProps} />
  );
